import * as React from 'react';
export const IcRename = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.43 4.63a1 1 0 00-1.86 0l-5.5 14a1 1 0 000 .77c.11.24.307.429.55.53a1 1 0 00.77 0c.24-.11.429-.307.53-.55L6.65 15h5.7l1.72 4.37a1 1 0 00.21.32 1 1 0 00.32.23 1.07 1.07 0 00.79.01 1 1 0 00.32-.21 1 1 0 00.23-.32A1 1 0 0016 19a1.07 1.07 0 00-.07-.39l-5.5-13.98zm-3 8.37L9.5 7.73 11.57 13H7.43zM19 3a1 1 0 00-1 1v16a1 1 0 002 0V4a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
